import { render } from "./App.vue?vue&type=template&id=374a00aa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=374a00aa&lang=scss"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__